import React, {useRef, useEffect} from "react";

import { useSelector } from "react-redux";

const UPDATE_COLOR = "rgb(173, 228, 234)";
const ADD_COLOR = "rgb(175, 233, 175)";
const DELETE_COLOR = "rgb(255, 212, 212)";

const Rows = ({ rowData, index, difftype , diffdata }) => {
    
    const remark = rowData?.find((search) => {
        return search.name === "remark"
    })

    const remark_chk = remark?.value !== "FALSE";

    const checkHide = rowData?.find((search) => {
        return search.name === "hide"
    })

    let cnt = 0;

    // urs 62번, Admin 권한만 hide 된거 보여주기 (32 ~ 35번째 줄까지 추가)
    const userSelector = useSelector((store) => store.user);

    let diffstyle = null;
    let remarkStyle;


    if(difftype === "delete") {
        diffstyle = {backgroundColor: DELETE_COLOR, color: "#999", textDecoration: "line-through"}
    } else if(difftype === "add") {//추가 연초록색
        diffstyle = {backgroundColor: ADD_COLOR}
    }
    
    if (diffdata?.["remark"]) {
        remarkStyle = UPDATE_COLOR;
    }
    
    //조건 줘서 컬러
    if (checkHide?.value === "TRUE" && !userSelector.isAdmin) {
        return null
    } else {
        return (
            <>
                <tr rowSpan={remark_chk ? "2" : "1"} style={diffstyle} >
                    {rowData.map((vv, ii) => {
                        
                        let checkupdate = diffdata?.[vv.name];
                        checkupdate = checkupdate !== undefined ? {backgroundColor: UPDATE_COLOR} : {}
                        const grayFill = !vv.value && !diffstyle ? {backgroundColor: "#EEE"} : {}
                        if (vv.type === "checkbox" || vv.type2 === "hidden") {
                            return null
                        } else if (vv.type === "select") {
                            cnt++;            
                            if (vv.options === "sample") {
                                return <td key={index + "" + ii} className={(!vv.label ? "no-text" : "")} style={{ ...grayFill, ...checkupdate}}>
                                <span className="for-diff block">{diffdata?.["samplePointNm"]}</span>{vv.label}
                            </td>
                            } else if(vv.options === "qcoption") {
                                return <td key={index + "" + ii} className={(!vv.label ? "no-text" : "")} style={{ ...grayFill, ...checkupdate}}>
                                <span className="for-diff block">{diffdata?.["optionCd"]}</span>{vv.label}
                            </td>
                            } else { 
                                return <td key={index + "" + ii} className={!vv.value ? "no-text" : ""} style={{ ...grayFill, ...checkupdate, ...vv.style}}>
                                <span className="for-diff block">{diffdata?.[vv.name]}</span>{vv.value}
                            </td>
                            }
                        } else if(vv.type === "seperator") {
                            cnt++;
                            return <td key={index + "" + ii} style={{ ...grayFill, padding: 0, textAlign: "center", borderRight: "0"}}>
                                {vv.value}
                            </td>
                        } else {
                            cnt++;
                            return <td key={index + "" + ii} className={!vv.value ? "no-text" : ""} style={{...grayFill, ...vv.style, ...vv.borderStyle,...checkupdate, }}>
                            <span className="for-diff block">{diffdata?.[vv.name]}</span>{vv.value}
                        </td>
                        
                        }
                    })}
                </tr>

                <tr className={(remark_chk ? "" : "d-none")} style={diffstyle}>
                    <td colSpan={cnt} style={{textAlign: "left", backgroundColor : remarkStyle} }>
                        <span className="for-diff block">{diffdata?.["remark"] === "FALSE" ? "" : diffdata?.["remark"]}</span>{remark?.value}
                    </td>
                </tr>
            </>
        )
    }
}

export default React.memo(Rows);